<div
  [class]="
    'flex items-center flex-row flex-nowrap justify-between content-stretch gap-(--gap-normal) h-16 pl-(--space-6) pr-(--space-10) transition-colors ' +
    (isImpersonating() ? 'bg-orange-50' : 'bg-(--surface-2)')
  ">
  <div class="flex flex-row gap-0 items-center justify-start">
    <app-logo-component class="mr-(--space-12)" />
    <app-search-dropdown
      [options]="groupedAssets"
      [loading]="isLoading"
      [group]="true"
      [placeholder]="'common.placeholders.searchAsset' | transloco"
      optionGroupLabel="label"
      optionGroupChildren="items"
      (search)="searchAssets($event)"
      (optionSelected)="onAssetSelected($event)"
      (cleared)="onSearchCleared()"
      class="">
      <ng-template #groupTemplate let-group>
        <div class="flex justify-start items-center text-(color:--text-secondary)">
          <ces-icon size="md" containerSize="xs">source_environment</ces-icon>
          <span class="text-(color:--text-secondary) font-light text-sm ml-(--space-1)">{{ group.label }}</span>
        </div>
      </ng-template>
    </app-search-dropdown>
  </div>
  <div class="gap-(--gap-loose) flex flex-row items-center align-middle">
    @if (isAdminOrDev()) {
      <ces-toolbar-button
        [label]="'navigation.settings' | transloco"
        icon="settings"
        [pathMatch]="'/configuration'"
        pathMatchMode="subset"
        href="/configuration/definition"
        (onClick)="router.navigate(['/configuration/definition'])" />
    }
    <ces-toolbar-button
      [label]="'navigation.logs' | transloco"
      icon="pending_actions"
      [pathMatch]="'/eventlogs'"
      href="/eventlogs"
      (onClick)="router.navigate(['/eventlogs'])" />

    @if (currentUser) {
      <div class="flex items-center gap-(--gap-normal)">
        <ces-toolbar-button
          #userMenuButton
          variant="toolbarButton"
          [label]="displayedUserName()"
          [icon]="displayedUserInitials()"
          [config]="{ isInitials: true }"
          [items]="menuItems()"
          (menuShow)="onUserMenuShow()">
          <ng-template #menuItemTemplate let-item>
            @if (item.routerLink) {
              <a
                [routerLink]="item.routerLink"
                class="p-menuitem-link flex items-center gap-(--gap-normal) p-(--space-2) no-underline text-inherit">
                @if (item.icon) {
                  <span class="material-symbols">
                    {{ RouteUtils.getIconClass(item.icon) }}
                  </span>
                }
                <span>{{ item.label }}</span>
              </a>
            } @else {
              <div class="p-menuitem-link flex items-center gap-(--gap-normal) p-(--space-2)">
                @if (item.icon) {
                  <span class="material-symbols">
                    {{ RouteUtils.getIconClass(item.icon) }}
                  </span>
                }
                <span>{{ item.label }}</span>
              </div>
            }
          </ng-template>
        </ces-toolbar-button>
        @if (isImpersonating()) {
          <button
            type="button"
            class="inline-flex items-center gap-(--gap-tight) px-(--space-2) py-(--space-1) rounded-full bg-orange-100 text-orange-950 text-xs font-medium cursor-pointer hover:bg-orange-200 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(color:--p-primary-color)"
            (click)="stopImpersonation()"
            [title]="'navigation.impersonation.clickToStop' | transloco">
            <span class="material-symbols text-sm" aria-hidden="true">sync</span>
            <span>{{ 'navigation.impersonation.testMode' | transloco }}</span>
          </button>
        }
      </div>
    } @else {
      <ces-toolbar-button [label]="'navigation.notConnected' | transloco" icon="error" />
    }

    <ces-toolbar-button #langMenuButton [label]="currentLangLabel()" [items]="languageMenuItems()" (menuShow)="onLangMenuShow()" />
  </div>
</div>
<div [class]="'absolute bottom-0 w-full transition-all ' + (loadingService.loading() ? 'opacity-50' : 'opacity-0')">
  <p-progressbar
    [mode]="loadingService.progressMode()"
    [showValue]="false"
    [style]="{ height: '1px' }"
    [value]="loadingService.progressValue()" />
</div>

<!-- Impersonation Dialog -->
@if (showImpersonationDialog()) {
  <p-dialog
    [header]="'navigation.impersonation.title' | transloco"
    [(visible)]="showImpersonationDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '450px' }"
    [breakpoints]="{ '640px': '95vw' }"
    aria-describedby="impersonation-description"
    (onHide)="closeImpersonationDialog()">
    <div class="flex flex-col gap-(--gap-relaxed)">
      <p id="impersonation-description" class="text-sm text-(color:--text-secondary)">
        {{ 'navigation.impersonation.description' | transloco }}
      </p>

      <div class="flex flex-col gap-(--gap-normal)">
        <label for="impersonation-user" class="text-sm font-semibold">{{ 'navigation.impersonation.userLabel' | transloco }}</label>
        <p-dropdown
          id="impersonation-user"
          [options]="availableUsers()"
          [(ngModel)]="selectedImpersonationUserId"
          optionLabel="displayName"
          optionValue="id"
          [placeholder]="'common.placeholders.selectUser' | transloco"
          [filter]="true"
          filterBy="displayName,email"
          [showClear]="true"
          appendTo="body"
          [style]="{ width: '100%' }"
          panelStyleClass="min-w-full">
          <ng-template let-user pTemplate="item">
            <div class="flex flex-col">
              <span class="font-semibold">{{ user.displayName }}</span>
              <span class="text-xs text-(color:--text-secondary)">{{ user.email }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="flex justify-end gap-(--gap-normal)">
        <ces-button-tertiary [label]="'common.buttons.cancel' | transloco" (onClick)="closeImpersonationDialog()" />
        <ces-button
          [label]="'common.buttons.test' | transloco"
          icon="play_arrow"
          [disabled]="!selectedImpersonationUserId()"
          (onClick)="startImpersonation()" />
      </div>
    </div>
  </p-dialog>
}
